'use strict';
//
angular.module('core').run([
  'Authentication', '$location', '$rootScope',
  function (Authentication, $location, $rootScope) {
    // On url change scroll to top
    $rootScope.$on('$stateChangeSuccess', function () {
      window.scrollTo(0, 0);
    });
  }
]);

angular.module('core').controller('HomeController', [
  'Authentication', '$location', '$scope',
  function (Authentication, $location, $scope) {
    //This provides Authentication context.
    //if authenticated redirect to mobile apps
    var authentication = Authentication;
    if (authentication.user && authentication.user._id) {
      $location.path('projects');
    }
    else {
      //if not authenticated redirect to login page
      $location.path('login');
    }
  }
]);
